import React from 'react';
import BrandLogo from './BrandLogo';

/**
 * Vertical step-list sidebar for the Annual Check-In form.
 */
export default function ProgressSidebar({
  currentStep,
  steps,
  onStepClick,
  stepStatuses = [],
  lockFutureSteps = false,
}) {
  const scheduleIdx = steps.findIndex((s) => s.key === 'schedule_meeting');
  const lastVisibleIdx = lockFutureSteps && scheduleIdx >= 0
    ? scheduleIdx
    : steps.length - 1;
  return (
    <nav className="cashflow-sidebar d-none d-lg-flex flex-column p-3">
      <div className="mb-3 text-center"><BrandLogo size={48} /></div>
      <p className="text-uppercase fw-semibold small text-center mb-3 px-1" style={{ color: '#fff' }}>
        Investment Management Review
      </p>

      <ol className="list-unstyled flex-fill cashflow-step-list">
        {steps.map((step, idx) => {
          if (idx > lastVisibleIdx) return null;
          const isActive = idx === currentStep;
          const status = stepStatuses[idx] || 'empty';

          let stateClass = 'cashflow-step--empty';
          if (isActive) {
            stateClass = 'cashflow-step--active';
          } else if (status === 'complete') {
            stateClass = 'cashflow-step--done';
          } else if (status === 'partial') {
            stateClass = 'cashflow-step--partial';
          }

          return (
            <li
              key={idx}
              className={`cashflow-step-item ${stateClass}`}
              onClick={() => onStepClick && onStepClick(idx)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === 'Enter' && onStepClick && onStepClick(idx)
              }
            >
              <span className="cashflow-step-indicator">
                {!isActive && status === 'complete' ? (
                  <i className="bi bi-check-lg" />
                ) : !isActive && status === 'partial' ? (
                  <i className="bi bi-pencil-fill" style={{ fontSize: '0.6rem' }} />
                ) : idx === 0 ? (
                  <i className={`bi ${step.icon}`} style={{ fontSize: '0.75rem' }} />
                ) : (
                  <span className="cashflow-step-number">{idx}</span>
                )}
              </span>
              <span className="cashflow-step-label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
